export default __webpack_public_path__ + "static/media/DSC.dac457a3.png";